module.exports = __webpack_public_path__ + "static/media/user-lock.c530d4d8.svg";